module.exports = __webpack_public_path__ + "img/digitalIdentity7.2fc0044a.png";